import { render, staticRenderFns } from "./extraElement.vue?vue&type=template&id=6317befe&scoped=true&"
import script from "./extraElement.vue?vue&type=script&lang=js&"
export * from "./extraElement.vue?vue&type=script&lang=js&"
import style0 from "./extraElement.vue?vue&type=style&index=0&id=6317befe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6317befe",
  null
  
)

export default component.exports